import React from 'react';
import styled from 'styled-components';

import Icon from 'components/shared/Icon';

function Swap(props) {
  return (
    <button data-name="property-toggle" type="button" {...props}>
      <Angle />
    </button>
  );
}

const Angle = styled(Icon).attrs({
  icon: 'angle',
})``;

Swap.Angle = Angle;

const StyledSwap = styled(Swap)`
  margin: 0;
  padding: 0;
  font-size: var(--font-size-base);
  color: var(--color-secondary-text);
  outline: none;
  background: none;
  cursor: pointer;
  border: none;

  ${Angle} {
    transform: rotate(180deg);
    transition: all 0.2s;
  }
`;

export default StyledSwap;
